// Product types
export const COURSE_ENTITLEMENT_PRODUCT_TYPE = 'Course Entitlement';
export const ENROLLMENT_CODE_PRODUCT_TYPE = 'Enrollment Code';
export const SEAT_PRODUCT_TYPE = 'Seat';

// Certificate types
export const VERIFIED_CERTIFICATE_TYPE = 'verified';
export const CREDIT_CERTIFICATE_TYPE = 'credit';

// Order Details message keys
export const ENTITLEMENT_MESSAGE_KEY = 'entitlement';
export const ENROLLMENT_CODE_MESSAGE_KEY = 'enrollment.code';
export const VERIFIED_SEAT_MESSAGE_KEY = 'seat.verified';
export const CREDIT_SEAT_MESSAGE_KEY = 'seat.credit';
export const SEAT_MESSAGE_KEY = 'seat';
